import { useEffect, useState } from 'react';
import './Countdown.css';

const targetTimestamp = Date.UTC(2026, 1, 22, 4, 30, 0);
const secondsInMinute = 60;
const minutesInHour = 60;
const hoursInDay = 24;

type TimeLeft = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

const getTimeLeft = (): TimeLeft => {
  const now = Date.now();
  const diffMs = Math.max(0, targetTimestamp - now);
  const totalSeconds = Math.floor(diffMs / 1000);

  const days = Math.floor(totalSeconds / (hoursInDay * minutesInHour * secondsInMinute));
  const hours = Math.floor(
    (totalSeconds % (hoursInDay * minutesInHour * secondsInMinute)) /
      (minutesInHour * secondsInMinute),
  );
  const minutes = Math.floor((totalSeconds % (minutesInHour * secondsInMinute)) / secondsInMinute);
  const seconds = totalSeconds % secondsInMinute;

  return { days, hours, minutes, seconds };
};

const formatUnit = (value: number, pad = false) => {
  if (!pad) {
    return String(value);
  }
  return String(value).padStart(2, '0');
};

function Countdown() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(() => getTimeLeft());

  useEffect(() => {
    const interval = window.setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);

    return () => window.clearInterval(interval);
  }, []);

  return (
    <main className="countdown">
      <div className="countdown-inner">
        <div className="countdown-heading">
          <h1 className="countdown-title">Countdown</h1>
          <p className="countdown-subtitle">For the most special day of our lives</p>
          <p className="countdown-date">22 February 2026 · 10:00 am IST</p>
        </div>
        <div className="countdown-grid">
          <div className="countdown-card">
            <span className="countdown-value">{formatUnit(timeLeft.days)}</span>
            <span className="countdown-label">Days</span>
          </div>
          <div className="countdown-card">
            <span className="countdown-value">{formatUnit(timeLeft.hours, true)}</span>
            <span className="countdown-label">Hours</span>
          </div>
          <div className="countdown-card">
            <span className="countdown-value">{formatUnit(timeLeft.minutes, true)}</span>
            <span className="countdown-label">Minutes</span>
          </div>
          <div className="countdown-card">
            <span className="countdown-value">{formatUnit(timeLeft.seconds, true)}</span>
            <span className="countdown-label">Seconds</span>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Countdown;
